import { render, staticRenderFns } from "./EditorialManage.vue?vue&type=template&id=73037312&"
import script from "./EditorialManage.vue?vue&type=script&lang=js&"
export * from "./EditorialManage.vue?vue&type=script&lang=js&"
import style0 from "./EditorialManage.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports